export const login = 'knkmob.login';

export const token_timeout = 'knkmob.token.timeout';

export const pwa_never_display = 'knkmob.pwa.neverdisplay';

export const last_access_type = 'knkmob.LastAccessType';

export const last_cmp = 'knkmob.LastCmp';

export const last_ws = 'knkmob.LastWs';
